module.exports = __webpack_public_path__ + "static/cashInfo-ee2acdb12891568cc4b45a8da9622fa8.svg";